export const BENCHMARKS_TITLE = 'Benchmarks';

export function companyDisplayName(
  companyName: string,
  isSelfCompany: boolean
) {
  return `${companyName}${isSelfCompany ? ' (you)' : ''}`;
}
